import { observer } from "mobx-react-lite";
import { useContext, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import ConfirmPresentationOpen from "./ConfirmPresentationOpen";
import DocumentPinForm from "./DocumentPinForm";
import { enableBodyScroll } from "body-scroll-lock";
interface IParams {
  zone: string;
}

const DocumentPinPage: React.FC<IParams> = ({ zone }) => {
  const rootStore = useContext(RootStoreContext);
  const { company } = rootStore.commonStore;
  const { pinValidated, showPresentationPage} = rootStore.guestStore;
console.log("DocumentPinPage")

  const handleResize = () => {
    let responsivePaddingTop = document.documentElement.clientHeight * 0.05;
    document.body.style.paddingTop = `${responsivePaddingTop}px`;
  };

  useEffect(() => {
    let responsivePaddingTop = document.documentElement.clientHeight * 0.05;
    window.addEventListener("resize", handleResize);
    document.body.classList.add("form-membership");
    document.body.style.paddingTop = `${responsivePaddingTop}px`;
    enableBodyScroll(document.body);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.classList.remove("form-membership");
      document.body.style.paddingTop = "";
    };
  }, []);

  return (
    <>
      <Container>
        <Row>
          <Col />
          <Col lg="8">
            <Row className="justify-content-center">
              {pinValidated === true && showPresentationPage === false && company?.isGlobalGuestFullyEnabled !== true ? (
                <ConfirmPresentationOpen />
              ) : (
                <DocumentPinForm zone={zone} />
              )}
            </Row>
          </Col>
          <Col />
        </Row>
      </Container>
    </>
  );
};

export default observer(DocumentPinPage);
